import { useState } from "react";
import { Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { GerarDossierFinal } from "@/components/DossierFinalDialog";
import { CasaPronta } from "@/components/CasaPronta";
import { navyBtn, glow } from "@/components/NextStep";

export function PrepararEscritura({ p, onChange }) {
  const [open, setOpen] = useState(false);
  const cp = (p.documents || []).some((d) => d.key === "direito_preferencia" && d.status !== "nao_aplica");
  return (
    <div data-testid="prepare-deed">
      <button onClick={() => setOpen(true)} className={`${navyBtn} ${glow}`} data-testid="prepare-deed-btn"><Check size={17} strokeWidth={2.5} />Preparar escritura</button>
      <div className="text-[13px] text-slate-500 text-center mt-1.5">Dossier + dados para a Casa Pronta</div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl bg-white" data-testid="prepare-deed-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading navy-text">Preparar escritura</DialogTitle>
            <DialogDescription>Todos os documentos estão válidos. Gere o dossier para o cartório{cp ? " e copie os dados para a Casa Pronta" : ""}.</DialogDescription>
          </DialogHeader>
          <section className="space-y-2">
            <h3 className="font-semibold text-sm navy-text">1. Dossier final</h3>
            <GerarDossierFinal pid={p.id} ref_={p.ref} ready provisional={!!p.closing?.final_blocker} blocker={p.closing?.final_blocker} onChange={onChange} block />
          </section>
          {cp && (
            <section className="space-y-1 pt-2">
              <h3 className="font-semibold text-sm navy-text">2. Casa Pronta (direito de preferência)</h3>
              <CasaPronta pid={p.id} />
            </section>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
